"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Pc = function Pc(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return _react["default"].createElement(_SvgIcon["default"], {
    title: "pc",
    size: size
  }, _react["default"].createElement("path", {
    fill: color,
    d: "M7.33 2.2h.2c.4.03.45.15.46.66v3.43c0 .59-.07.66-.66.66h-1.9v.32h.61a.2.2 0 01.18.1l.16.34a.2.2 0 01-.17.29H3.93a.2.2 0 01-.18-.29l.16-.33a.2.2 0 01.18-.11h.61v-.32H2.92c-.7 0-.77-.03-.78-.66V2.66c.04-.4.15-.45.67-.46h4.52zm-.25.73H3.06c-.1 0-.19.08-.19.18v2.93c0 .1.08.18.19.18h4.02c.1 0 .18-.08.18-.18V3.11c0-.1-.08-.18-.18-.18zM3.6 0c.4 0 .72.32.72.72V1.9H3.6V.72H.72v4.32h1.12v.72H.72A.72.72 0 010 5.04V.72C0 .32.32 0 .72 0H3.6zM1.44 3.96a.36.36 0 110 .72.36.36 0 010-.72zm4.3-.6c.11 0 .2.1.2.2v.88a.2.2 0 01-.2.2h-.18a.2.2 0 01-.2-.2v-.88c0-.1.09-.2.2-.2h.18zm-1.16 0c.1 0 .2.1.2.2v.88a.2.2 0 01-.2.2h-.19a.2.2 0 01-.2-.2v-.88c0-.1.1-.2.2-.2h.19zm-3.14-.84a.36.36 0 110 .72.36.36 0 010-.72zm0-1.44a.36.36 0 110 .72.36.36 0 010-.72z"
  }));
};

Pc.defaultProps = {
  size: 8,
  color: '#444'
};
var _default = Pc;
exports["default"] = _default;